export const GET_ARTICLE_LIST = 'GET_ARTICLE_LIST';
export const SET_ACTIVE_ARTICLE_INDEX = 'SET_ACTIVE_ARTICLE_INDEX';
export const PASS_WELCOME = 'PASS_WELCOME';
